import { __spreadArray } from 'tslib';

var init = function (draft, action) {
    var _a;
    var _b = action.payload, defaultState = _b.defaultState, filterConfig = _b.filterConfig, initialFilters = _b.initialFilters, name = _b.name;
    var initialFilterKeys = Object.keys(initialFilters);
    var hasInitialFilters = !!Object.keys(initialFilters).length;
    var defaultStateDisplayedFilters = defaultState === null || defaultState === void 0 ? void 0 : defaultState.displayedFilters;
    var displayedFilters = defaultStateDisplayedFilters
        ? __spreadArray([], defaultStateDisplayedFilters, true) : [];
    var filters = {};
    if (((_a = draft[name]) === null || _a === void 0 ? void 0 : _a.initialized) && !hasInitialFilters)
        return;
    filterConfig.forEach(function (filter) {
        var _a, _b;
        if (hasInitialFilters) {
            if (initialFilterKeys.includes(filter.name)) {
                pushUnique(displayedFilters, filter.name);
                var filterValues = initialFilters[filter.name];
                filters[filter.name] = Array.isArray(filterValues)
                    ? Array.from(new Set(filterValues))
                    : filterValues;
            }
            else if (filter.required) {
                pushUnique(displayedFilters, filter.name);
                filters[filter.name] = filter.defaultValues;
            }
            else {
                if (filter.static)
                    pushUnique(displayedFilters, filter.name);
            }
        }
        else {
            if ((_a = defaultState === null || defaultState === void 0 ? void 0 : defaultState.filters) === null || _a === void 0 ? void 0 : _a[filter.name]) {
                filters[filter.name] = (_b = defaultState === null || defaultState === void 0 ? void 0 : defaultState.filters) === null || _b === void 0 ? void 0 : _b[filter.name];
                pushUnique(displayedFilters, filter.name);
            }
            else if (!filter.defaultValues) {
                if (filter.static) {
                    filters[filter.name] = filter.defaultValues;
                    pushUnique(displayedFilters, filter.name);
                }
            }
            else {
                pushUnique(displayedFilters, filter.name);
                filters[filter.name] = filter.defaultValues;
            }
        }
    });
    draft[name] = {
        config: filterConfig,
        displayedFilters: displayedFilters,
        defaultFilters: JSON.parse(JSON.stringify(displayedFilters)),
        filters: filters,
        initialized: true
    };
};
var pushUnique = function (arr, item) {
    if (arr.includes(item))
        return;
    arr.push(item);
};

export { init };
//# sourceMappingURL=init.esm.js.map
